import { render, staticRenderFns } from "./TenantFeatures.vue?vue&type=template&id=66ef0c2a&"
import script from "./TenantFeatures.vue?vue&type=script&lang=ts&"
export * from "./TenantFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports